import {
    ChartLineProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property';
import type { ChartContext } from '@src/slide/domain/ui-model/element-modeles/chart-models/context';
import type { IChartLine } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';
import { NullableDeep } from '../chart-shape-property.interface';
import { IAxisProperty } from './axis.interface';
import { GridlinesType } from '../../../constant/chart';

const DEFAULT_AXIS_LINE_COLOR = '#868687';

export class GridLineProperty extends ChartLineProperty<IChartLine> {
    protected defaultLineFill = DEFAULT_AXIS_LINE_COLOR;
    private parentProperty: IAxisProperty;

    public constructor(
        protected uiData: IChartLine,
        protected context: ChartContext,
        private gridlinesType: GridlinesType,
    ) {
        super(uiData, context);
    }

    public init(parentProperty: IAxisProperty) {
        this.parentProperty = parentProperty;
        return this;
    }

    public updateProps(props?: Partial<IChartLine>, removeProps?: Partial<NullableDeep<IChartLine>> | null): void {
        this.parentProperty.updateProps(
            { [this.gridlinesType]: props },
            removeProps ? { [this.gridlinesType]: removeProps } : undefined,
        );
    }
}
